import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  ViewContainerRef,
  ChangeDetectorRef,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { MyAccountService } from "../modals/my-account-modal.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { HotToastService } from "@ngneat/hot-toast";

import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { MomentModule } from "ngx-moment";
import { NgFor, NgIf } from "@angular/common";

/* This is a component which we pass in modal*/
@Component({
    selector: "ch-my-devices-modal",
    templateUrl: "./my-devices-modal.component.html",
    styleUrls: ["./my-devices-modal.component.scss"],
    imports: [
        NgFor,
        NgIf,
        MomentModule,
    ]
})
export class MyDevicesModalComponent implements OnInit {
  user: any = {};
  data: any = {};
  devices = [];
  loading = false;
  client_id = null;

  public modalRef: BsModalRef;

  constructor(
    public bsModalRef: BsModalRef,
    private myAccountService: MyAccountService,
    private localStorage: LocalStorageService,
    private modalService: BsModalService,
    private toastr: HotToastService,
    private _elRef: ElementRef,
    private cdr: ChangeDetectorRef,
    vcr: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");

    this.myAccountService.getMyDevices().then((res: any) => {
      console.log("devices", res);
      this.devices = res;
      this.cdr.detectChanges();
    });

    FingerprintJS.load({
      monitoring: false,
    }).then((fpPromise) => {
      fpPromise.get().then((result) => {
        this.client_id = result.visitorId.slice(result.visitorId.length - 6);
      });
    });
  }

  removeDevice(uuid) {
    this.myAccountService.removeDevice(uuid).then((res: any) => {
      this.toastr.success(res.message);
      this.devices = this.devices.filter((device) => device.uuid !== uuid);
      this.cdr.detectChanges();
    });
  }
}
